import VueParser from '@vuedoc/parser';

export function parseVueCode(code) {
  return VueParser.parse({
    filecontent: code,
  });
}
